import { render, staticRenderFns } from "./AlertaAccesoBloqueado.vue?vue&type=template&id=dc11b994&scoped=true"
import script from "./AlertaAccesoBloqueado.vue?vue&type=script&lang=js"
export * from "./AlertaAccesoBloqueado.vue?vue&type=script&lang=js"
import style0 from "./AlertaAccesoBloqueado.vue?vue&type=style&index=0&id=dc11b994&prod&scoped=true&lang=css"
import style1 from "./AlertaAccesoBloqueado.vue?vue&type=style&index=1&id=dc11b994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc11b994",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
